export default __webpack_public_path__ + "011841d63b638bc931af112bfcc1c0a8.jpeg";